import UnsupportedBrowserPage from './UnsupportedBrowserPage';

export default UnsupportedBrowserPage;
